// extracted by mini-css-extract-plugin
module.exports =  {"root":"vlkDMuVezbS_TCWuwHwk","icon":"IjcitmGIjQfHLAmbY7Ab","title":"b9bVeB7ZOor8X4SsYSbV","subtitle":"f_AYWliuBnUJqzM_oNRU","small":"VKFuTUsviPgmihXyYbJF"};